import type { OracleQuote } from '../types'

/**
 * 加载 Z 哥语录库
 * 注意: oracle.json 顶层是 { section, quotes: [...] }
 * 不是普通章节卡片的 { cards: [...] } 结构
 */
export async function loadOracleQuotes(): Promise<OracleQuote[]> {
  const response = await fetch('/cards/oracle.json')
  if (!response.ok) {
    throw new Error(`Failed to load oracle: ${response.status}`)
  }
  const data = await response.json()
  if (Array.isArray(data)) return data
  if (data.quotes && Array.isArray(data.quotes)) return data.quotes
  throw new Error('Invalid oracle.json structure')
}

/**
 * 抽卡算法: 在指定语录池里随机抽一个, 可选择避开最近抽过的 N 个
 */
export function drawQuote(
  pool: OracleQuote[],
  avoidIds: string[] = []
): OracleQuote {
  if (pool.length === 0) {
    throw new Error('Empty oracle pool')
  }

  // 优先级: 全抽 → 避开历史的抽 → 完全随机
  const avoidSet = new Set(avoidIds)

  // 1. 全部都抽过 → 从全池随机
  const unDrawn = pool.filter(q => !avoidSet.has(q.id))
  if (unDrawn.length === 0) {
    return pool[Math.floor(Math.random() * pool.length)]!
  }

  // 2. 有未抽过的, 80% 概率从 unDrawn 抽, 20% 从全池随机 (允许偶尔重复)
  if (Math.random() < 0.8) {
    return unDrawn[Math.floor(Math.random() * unDrawn.length)]!
  }
  return pool[Math.floor(Math.random() * pool.length)]!
}